// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* .traine-box {\n    min-height: 50px !important;\n} */", "",{"version":3,"sources":["webpack://src/dashboards/da-dashboard/pages/overview/index.css"],"names":[],"mappings":"AAAA;;GAEG","sourcesContent":["/* .traine-box {\n    min-height: 50px !important;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
